const toggleStickyScrollSection = () => {
	if (document.querySelector(".sticky-scroll-section-container")) {
		const stickySections = document.querySelectorAll(".sticky-scroll-section-container");

		const StickyBottomIntersectionHandler = (entries) => {
			entries.forEach((entry, index) => {
				const bcr = entry.boundingClientRect;
				// use initial height of section to set the placeholder height
				const sectionHeight = entry.target.offsetHeight;
				const sectionContent = entry.target.querySelector(".sticky-scroll-section-content");
				const placeholder = entry.target.querySelector(".sticky-scroll-section-placeholder");
				const navBarHeight = document.querySelector(".sticky-header-container")?.offsetHeight;
				const shouldItemStick =
					index === 0
						? entry.target.offsetHeight + navBarHeight >= window.innerHeight
						: entry.target.offsetHeight >= window.innerHeight;

				const isBottomIntersecting = bcr.bottom < window.innerHeight * 0.75 && shouldItemStick;
				if (isBottomIntersecting) {
					// set sticky class on the current section
					sectionContent.classList.add("sticky");
					// set bottom of sticky content to complement the rootMargin
					sectionContent.style.bottom = window.innerHeight * 0.25 + "px";
					// set sticky placeholder height to sectionHeight
					placeholder.style.height = sectionHeight + "px";
				} else {
					// set sticky placeholder height to 0
					placeholder.style.height = "0px";
					// remove sticky class
					sectionContent.classList.remove("sticky");
				}
			});
		};

		const StickyBottomScrollObserver = new window.IntersectionObserver(
			StickyBottomIntersectionHandler,
			{
				root: null,
				rootMargin: "-75% 0px 0px 0px",
				threshold: 0
			}
		);

		const addIntersectionObserver = () => {
			stickySections.forEach((section) => {
				if (section) {
					StickyBottomScrollObserver.observe(section);
				}
			});
		};
		addIntersectionObserver();
	}
};

export default toggleStickyScrollSection;
